module.exports = __webpack_public_path__ + "static/media/more_horiz.77032216.svg";